import Call from '../../Call.v2';

const PeerclickCampaign = {
    update(campaignId, oldOfferId, newOfferId) {
        return Call(`peerclick/campaign/${campaignId}`, "POST", {oldOfferId, newOfferId})
    }
};

export default PeerclickCampaign;



// WEBPACK FOOTER //
// ./src/services/API/components/peerclick/PeerclickCampaign.js